import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// types
import { SupportRequestFormType } from '../../types/SupportRequestFormType';

interface RobotRegFormState {
    supportRequestloading: boolean;
    supportRequestSuccess: boolean | null;
    supportRequestError: string | null;
}

const initialState: RobotRegFormState = {
    supportRequestloading: false,
    supportRequestSuccess: null,
    supportRequestError: null,
};

const supportRequestReducer = createSlice({
    name: 'supportRequestForm',
    initialState,
    reducers: {
        postSupportRequestForm: (state, action: PayloadAction<SupportRequestFormType>) => {
            state.supportRequestloading = true;
        },
        postSupportRequestFormSuccess: (state, action: PayloadAction<string>) => {
            state.supportRequestloading = false;
            state.supportRequestSuccess = true;
        },
        postSupportRequestFormFailure: (state, action: PayloadAction<string>) => {
            state.supportRequestloading = false;
            state.supportRequestError = action.payload;
        },
        resetSupportRequestForm: (state) => {
            return initialState;
        },
    },
});

export const {
    postSupportRequestForm,
    postSupportRequestFormSuccess,
    postSupportRequestFormFailure,
    resetSupportRequestForm,
} = supportRequestReducer.actions;
export default supportRequestReducer.reducer;